export default String.raw`
{% if products.FilteringOptions.PriceFrom != null and products.FilteringOptions.PriceFrom > 0 -%}
    {% assign priceFromExists = true -%}
{% endif -%}
{% if priceFromExists or products.FilteringOptions.PriceTo != null -%}
    {% assign pricesExist = true -%}
{% else -%}
    {% assign pricesExist = false -%}
{% endif -%}

{% assign activeFiltersKeysString = "" -%}
{% for value in filter.Values -%}
    {% if value.Selected -%}
        {% capture stringToAdd -%}{{value.Field}}|{{filter.Heading}}|{{value.Value}}|{{value.Text}}||{% endcapture -%}
        {% assign activeFiltersKeysString = activeFiltersKeysString | Append: stringToAdd -%}
    {% endif -%}
{% endfor -%}

{% if activeFiltersKeysString == "" or manufacturerOrBrandExists -%}
    {% assign showManufacturerOrBrand = true -%}
{% endif -%}

{% if products.HeaderData != null and showManufacturerOrBrand and pricesExist == false -%}
    {% if products.HeaderData.Image or products.HeaderData.Description != "" or products.HeaderData.Heading != "" -%}
        {% include 'partials/textField/textField.html' with 'categoryDescription' -%}
    {% endif -%}
{% endif -%}
`